import React, { useState, useEffect } from "react";
import styles from "../Modules/Home.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-scroll";
import { heroPhoto } from "../imports";

const roles = [
  "Backend Python Engineer",
  "API Architect",
  "Django & FastAPI Developer",
  "Problem Solver",
];

const CODE_FRAGMENTS = [
  { code: "def",       top: "-9%",  left: "50%",  dur: "6s",   delay: "0s",   opacity: 0.42, anim: "A" },
  { code: "async",     top: "2%",   left: "84%",  dur: "7.5s", delay: "1.2s", opacity: 0.38, anim: "B" },
  { code: "@property", top: "25%",  left: "104%", dur: "8.2s", delay: "2.8s", opacity: 0.35, anim: "C" },
  { code: "__init__",  top: "55%",  left: "109%", dur: "6.8s", delay: "0.6s", opacity: 0.4,  anim: "A" },
  { code: "None",      top: "88%",  left: "95%",  dur: "7.2s", delay: "3.4s", opacity: 0.38, anim: "B" },
  { code: "yield",     top: "107%", left: "65%",  dur: "9s",   delay: "1.8s", opacity: 0.32, anim: "C" },
  { code: "await",     top: "107%", left: "35%",  dur: "6.5s", delay: "4s",   opacity: 0.35, anim: "A" },
  { code: "lambda",    top: "88%",  left: "5%",   dur: "7.8s", delay: "0.3s", opacity: 0.3,  anim: "B" },
  { code: "class",     top: "55%",  left: "-9%",  dur: "6.2s", delay: "2.4s", opacity: 0.38, anim: "C" },
  { code: "import",    top: "16%",  left: "2%",   dur: "8.5s", delay: "1s",   opacity: 0.33, anim: "A" },
];

function Home() {
  const [roleIndex, setRoleIndex] = useState(0);
  const [roleVisible, setRoleVisible] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const interval = setInterval(() => {
      setRoleVisible(false);
      setTimeout(() => {
        setRoleIndex((prev) => (prev + 1) % roles.length);
        setRoleVisible(true);
      }, 400);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div id="home" className={styles.hero}>
      <div className={styles.blob1} />
      <div className={styles.blob2} />
      <div className={styles.blob3} />

      <div className={`${styles.container} ${mounted ? styles.containerVisible : ""}`}>
        {/* Left content */}
        <div className={styles.left}>
          <span className={styles.eyebrow}>
            <span className={styles.dot} />
            Available for work
          </span>

          <h1 className={styles.name}>
            Hi, I'm <span className={styles.highlight}>Soulaimane</span>
          </h1>

          <div className={styles.roleWrapper}>
            <span className={`${styles.role} ${roleVisible ? styles.roleIn : styles.roleOut}`}>
              {roles[roleIndex]}
            </span>
          </div>

          <p className={styles.bio}>
            I build robust backend systems and APIs that scale.
            Passionate about clean architecture, performance, and elegant solutions.
          </p>

          <div className={styles.techStack}>
            {["Python", "Django", "FastAPI", "PostgreSQL", "Docker", "Redis", "AI Integration"].map((tech) => (
              <span key={tech} className={styles.techBadge}>{tech}</span>
            ))}
          </div>

          <div className={styles.actions}>
            <Link className={styles.btnPrimary} to="projects" spy smooth offset={-70} duration={1000}>
              View Projects
            </Link>
            <Link className={styles.btnSecondary} to="contact" spy smooth offset={-70} duration={1000}>
              Contact Me
            </Link>
          </div>
        </div>

        {/* Right — photo with floating code fragments */}
        <div className={styles.right}>
          <div className={styles.photoOuter}>
            <div className={styles.photoFrame}>
              <div className={styles.photoGlow} />
              <img src={heroPhoto} alt="Soulaimane" className={styles.photo} />
            </div>

            {CODE_FRAGMENTS.map((frag, i) => (
              <span
                key={i}
                className={`${styles.codeFragment} ${styles["float" + frag.anim]}`}
                style={{
                  top: frag.top,
                  left: frag.left,
                  animationDuration: frag.dur,
                  animationDelay: frag.delay,
                  "--fop": frag.opacity,
                }}
              >
                {frag.code}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.scrollIndicator}>
        <Link to="projects" spy smooth offset={-70} duration={1000}>
          <FontAwesomeIcon icon={faArrowDown} />
        </Link>
      </div>
    </div>
  );
}

export default Home;
